// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 13V21H14.9955V13H9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.9955 21H23V13H16.9955V21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 11V3H16.9955V11H23Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.9955 3H9V11H14.9955V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 3H1V11H7V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 13H7V21L1 21V13Z"}}]};

const ViewModuleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-module-filled',
    ref,
    icon: element,
  },
));

ViewModuleFilledIcon.displayName = 'ViewModuleFilledIcon';

export default ViewModuleFilledIcon;
